import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GenericButton from '../../common/GenericButton';
import ExportListItems from './ExportListItems';
import * as crosstabActions from '../../../actions/crosstabActions';
import Modal from '../../common/Modal/Modal';

import studyUniverseExportActive from '../../../images/export-base-icons/study_universe_export_active.png';
import studyUniverseExportDefault from '../../../images/export-base-icons/study_universe_export_default.png';

import * as CrosstabUtils from '../../../util/CrosstabUtils';

import { PREFERENCE_BASE_EXPORT_LIST, PREFERENCE_STUDY_UNIVERSE, PREFERENCE_BASE_EXPORT } from '../../../constants';

const confirmModalStyles = {
  width: 'auto',
  minWidth: '100%',
  maxWidth: '100%',
  height: 'auto',
  top: '0',
  left: '0',
};

class ExportBaseMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsLeft: [],
      itemsRight: [],
      selectedItemsLeft: [],
      selectedItemsRight: [],
      rightSelectionCount: 0,
      originalBaseLists: [],
      defaultPreferenceLabel: '',
      studyUniverseEnabled: this.props.selectedBase ===
        CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
      doNotShowAgainChecked: false,
      studyUniverseExport: this.props.selectedBase ===
        CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
                            ? studyUniverseExportActive : studyUniverseExportDefault,
    };
  }

  componentDidMount() {
    this.getListBasedonPreferences();
  }

  onDoNotShowInputClick = () => {
    this.setState({ doNotShowAgainChecked: true });
    this.baseConfirmModal.show();
  };

  getListBasedonPreferences = () => {
    // TODO: this should select data based on the user preference
    let leftSideBases = [];
    let rightSideBases = [];
    const leftSideSelection = [];
    let studyUniverseEnabled = false;
    let studyUniverseExport = studyUniverseExportDefault;
    studyUniverseEnabled = this.props.userPreference[PREFERENCE_STUDY_UNIVERSE];
    if (this.props.selectedBase === 'StudyUniverseKey' || this.props.userPreference[PREFERENCE_STUDY_UNIVERSE]) {
      // studyUniverseEnabled = true;
      studyUniverseExport = studyUniverseExportActive;
    }

    const userDefinedBases = this.props.BasesDataGridData.map(item => {
      return { text: item.originalTitle, id: item.id, keyword: item.keyword, type: 'user' };
    });
    const standardBaseLists = this.props.standardBaseLists.map(item => {
      return { text: item.label, id: item.expression, keyword: item.expression, type: 'standard' };
    });
    const originalBaseLists = [...userDefinedBases, ...standardBaseLists];
    const selectedBase = originalBaseLists.filter(item =>
      item.keyword === this.props.selectedBaseNode &&
      this.props.getItemType(item.type) === this.props.selectedBaseGroup
    );
    const selectedPreferenceLabel = this.props.userPreference[PREFERENCE_BASE_EXPORT];

    switch (selectedPreferenceLabel) {
      // When base is  User-Defined Only
      case PREFERENCE_BASE_EXPORT_LIST[0]: {
        leftSideBases = originalBaseLists.filter(item => item.type === 'standard');
        rightSideBases = userDefinedBases;

        this.setState({
          itemsLeft: leftSideBases,
          itemsRight: rightSideBases,
          selectedItemsLeft: leftSideBases,
          selectedItemsRight: [],
          rightSelectionCount: 0,
          originalBaseLists,
          studyUniverseEnabled,
          studyUniverseExport,
        });
        break;
      }
      // When base is  Standard Only
      case PREFERENCE_BASE_EXPORT_LIST[1]: {
        leftSideBases = userDefinedBases;
        rightSideBases = originalBaseLists.filter(item => item.type === 'standard');

        this.setState({
          itemsLeft: leftSideBases,
          itemsRight: rightSideBases,
          selectedItemsLeft: leftSideBases,
          selectedItemsRight: [],
          rightSelectionCount: 0,
          originalBaseLists,
          studyUniverseEnabled,
          studyUniverseExport,
        });
        break;
      }
      // When base is  User-Defined & Standard
      case PREFERENCE_BASE_EXPORT_LIST[2]: {
        rightSideBases = originalBaseLists;

        this.setState({
          itemsLeft: [],
          itemsRight: rightSideBases,
          selectedItemsLeft: [],
          selectedItemsRight: [],
          rightSelectionCount: 0,
          originalBaseLists,
          studyUniverseEnabled,
          studyUniverseExport,
        });
        break;
      }
      // When base is Current Selection
      case PREFERENCE_BASE_EXPORT_LIST[3]: {
        leftSideBases = originalBaseLists.filter(item =>
          !(item.keyword === this.props.selectedBaseNode &&
            this.props.getItemType(item.type) === this.props.selectedBaseGroup)
        );
        rightSideBases = selectedBase;
        leftSideBases.map(item => {
          item.selected = true;
          leftSideSelection.push(item.id);
          return item;
        });

        this.setState({
          itemsLeft: leftSideBases,
          itemsRight: rightSideBases,
          selectedItemsLeft: leftSideSelection,
          selectedItemsRight: [],
          rightSelectionCount: 0,
          originalBaseLists,
          studyUniverseEnabled,
          studyUniverseExport,
        });
        break;
      }
      default: break;
    }
  }

  addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    const itemsRemainingID = [];
    const selectionsID = [];

    this.state.itemsRight.map(item => {
      selections.push(item);
      return item;
    });
    this.state.itemsLeft.map(item => {
      if (item.selected) {
        item.selected = false;
        selections.push(item);
        selectionsID.push(item.id);
      } else {
        itemsRemaining.push(item);
        itemsRemainingID.push(item.id);
      }
      return item;
    });

    this.setState({
      itemsLeft: itemsRemaining,
      itemsRight: selections,
      rightSelectionCount: selections.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    });
  };

  removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    const rightSideBaseList = [];
    const itemsRemainingID = [];
    const selectionsID = [];

    this.state.itemsRight.map(item => {
      if (!item.selected) {
        itemsRemaining.push(item);
        itemsRemainingID.push(item.id);
        rightSideBaseList.push(item.id);
      } else {
        item.selected = false;
      }
      return item;
    });
    this.state.originalBaseLists.map(item => {
      if (rightSideBaseList.indexOf(item.id) === -1) {
        selections.push(item);
        selectionsID.push(item.id);
      }
      return item;
    });
    this.setState({
      itemsLeft: selections,
      itemsRight: itemsRemaining,
      rightSelectionCount: itemsRemaining.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    });
    // this.props.crosstabActions.exportBaseSelectionList({
    //   itemsLeft: selections,
    //   itemsRight: itemsRemaining,
    // });
  };

  handleMoveAllLeft = () => {
    this.setState({
      itemsRight: [],
      itemsLeft: this.state.originalBaseLists,
      rightSelectionCount: 0,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    });
  }

  handleMoveAllRight = () => {
    this.setState({
      itemsLeft: [],
      itemsRight: this.state.originalBaseLists,
      eftSelectionCount: 0,
      selectedItemsLeft: [],
      selectedItemsRight: [],
    });
  }


  handleLeftPanelClick = (id, clearExisting, shiftKey) => {
    if (!shiftKey) {
      const selectedBaseLists = clearExisting ? [] : [...this.state.selectedItemsLeft];

      // Check if the item is already selected then deselect them when user clicks twice.
      if (this.state.selectedItemsLeft.indexOf(id) === -1) {
        selectedBaseLists.push(id);
      }
      this.setState({ selectedItemsLeft: [...selectedBaseLists] });
    } else {
      const selectedBaseLists = [...this.state.selectedItemsLeft];
      const currentElement = id;
      const lastElement = selectedBaseLists.pop();
      let startIndex = null;
      let endIndex = null;

      // Determine the start and End Index
      this.state.itemsLeft.forEach((item, index) => {
        if (item.id === lastElement) {
          endIndex = index;
        } else if (item.id === currentElement) {
          startIndex = index;
        }
      });
      // Swap the Index
      if (startIndex > endIndex) {
        const temp = startIndex;
        startIndex = endIndex;
        endIndex = temp;
      }

      // Add the items between both the index.
      this.state.itemsLeft.forEach((item, index) => {
        if (startIndex !== undefined && startIndex !== null &&
           endIndex !== undefined && endIndex !== null) {
          if (index >= startIndex && index <= endIndex) {
            selectedBaseLists.push(item.id);
          }
        } else if (item.id === id) {
          selectedBaseLists.push(item.id);
        }
      });
      this.setState({ selectedItemsLeft: [...selectedBaseLists] });
    }
  }

  handleRightPanelClick = (id, clearExisting, shiftKey) => {
    if (!shiftKey) {
      const selectedBaseLists = clearExisting ? [] : [...this.state.selectedItemsRight];

      // Check if the item is already selected then deselect them when user clicks twice.
      if (this.state.selectedItemsRight.indexOf(id) === -1) {
        selectedBaseLists.push(id);
      }
      this.setState({ selectedItemsRight: [...selectedBaseLists] });
    } else {
      const selectedBaseLists = [...this.state.selectedItemsRight];
      const currentElement = id;
      const lastElement = selectedBaseLists.pop();
      let startIndex = null;
      let endIndex = null;

      // Determine the start and End Index
      this.state.itemsRight.forEach((item, index) => {
        if (item.id === lastElement) {
          endIndex = index;
        } else if (item.id === currentElement) {
          startIndex = index;
        }
      });
      // Swap the Index
      if (startIndex > endIndex) {
        const temp = startIndex;
        startIndex = endIndex;
        endIndex = temp;
      }

      // Add the items between both the index.
      this.state.itemsRight.forEach((item, index) => {
        if (startIndex !== undefined && startIndex !== null &&
            endIndex !== undefined && endIndex !== null) {
          if (index >= startIndex && index <= endIndex) {
            selectedBaseLists.push(item.id);
          }
        } else if (item.id === id) {
          selectedBaseLists.push(item.id);
        }
      });
      this.setState({ selectedItemsRight: [...selectedBaseLists] });
    }
  }

  handleCancelDefaultCheckbox = () => {
    this.baseConfirmModal.hide();
    this.setState({ doNotShowAgainChecked: false });
  };

  handleStudyUniverse = () => {
    this.setState({ studyUniverseEnabled: !this.state.studyUniverseEnabled });
  };

  render() {
    return (
      <div className="export-multiselect-modal-body">
        <div>
          <div className="width-left columns">
            <div className="base-left-label">Available Base(s)</div>
            <ExportListItems
              items={this.state.itemsLeft}
              selectedItems={this.state.selectedItemsLeft}
              handleSelection={this.handleLeftPanelClick}
              pane="left"
            />
            <div className="study_universe_component">
              <input
                type="checkbox"
                checked={this.state.studyUniverseEnabled}
                id="study-universe"
                onChange={() => this.handleStudyUniverse()}
              />
              <label htmlFor="study-universe">Include Study Universe</label>
            </div>
          </div>
          <div className="width-center columns">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={this.addSelected}
                {...(this.state.selectedItemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-add-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllRight}
                {...(this.state.itemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={this.removeSelected}
                {...(this.state.selectedItemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllLeft}
                {...(this.state.itemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

            </div>
          </div>
          <div className="width-right columns multi-select-list-right">
            <div className="base-study-display-holder large-12 medium-12">
              <div>Selected Base(s)</div>
            </div>
            <ExportListItems
              items={this.state.itemsRight}
              selectedItems={this.state.selectedItemsRight}
              handleSelection={this.handleRightPanelClick}
              pane="right"
            />
            <div className="modal-footer no-padding export-base-multi-button">
              <div className="large-12 margin-top-15">
                <GenericButton
                  btnStyle="button export-base"
                  name="Export"
                  {...(this.state.itemsRight.length > 0 || this.state.studyUniverseEnabled
                    ? {}
                    : { btnDisabled: true })}
                  {...(this.state.itemsRight.length > 0 || this.state.studyUniverseEnabled
                    ? {}
                    : { title: 'please select atleast one row or column' })}
                  onBtnClick={() =>
                    this.props.handleExportBasePopupBaseClick(
                      this.state.studyUniverseEnabled,
                      this.state.itemsLeft,
                      this.state.itemsRight,
                      )}
                />
                <div className="clear clearfix" />
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Confirm Change to Base Export"
          ref={node => (this.baseConfirmModal = node)}
          dialogStyles={confirmModalStyles}
          closeTracker={() => this.handleCancelDefaultCheckbox()}
        >
          <div>
            <p>By selecting OK you will no longer be required to select your base(s) prior to
            exporting. All Excel exports will include base(s) with the following preference
            option</p>
            <p>Default Export Preference: <b>Currently Selected Base</b></p>
            <p>You can always changes these selections under <a>Preferences</a></p>
          </div>
          <div className="modal-btn-container">
            <GenericButton
              btnStyle="button export-popup-ok-btn"
              name="OK"
              btnDisabled
              title="Coming soon"
            />
            <GenericButton
              name="Cancel"
              onBtnClick={() => this.handleCancelDefaultCheckbox()}
            />
          </div>
        </Modal>
      </div>
    );
  }
}
ExportBaseMultiSelect.propTypes = {
  selectedBase: PropTypes.string,
  standardBaseLists: PropTypes.arrayOf(PropTypes.object),
  BasesDataGridData: PropTypes.arrayOf(PropTypes.object),
  exportBaseSelectionList: PropTypes.shape({
    itemsLeft: PropTypes.arrayOf(PropTypes.object),
    itemsRight: PropTypes.arrayOf(PropTypes.object),
    universalStudy: PropTypes.bool,
  }),
  crosstabActions: PropTypes.shape({
    exportBaseSelectionList: PropTypes.func,
  }),
  userPreference: PropTypes.shape({
    _be: PropTypes.string,
    _su: PropTypes.bool,
  }),
  getItemType: PropTypes.func,
  selectedBaseNode: PropTypes.string,
  selectedBaseGroup: PropTypes.string,
  handleExportBasePopupBaseClick: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    selectedBase: state.selectedBase.selectedBase,
    BasesDataGridData: state.crosstab.BasesDataGridData,
    selectedBaseNode: state.selectedBase.selectedBaseNode,
    selectedBaseGroup: state.selectedBase.selectedBaseGroup,
    exportBaseSelectionList: state.crosstab.exportBaseSelectionList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
  )(ExportBaseMultiSelect);
